import { ReactNode } from 'react';
import {
  Dialog as MuiDialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import { Button } from '@nordictrustee/nt-ui-library';
import { useDetectBreakpoint } from 'hooks/useDetectBreakpoint';
import classes from './Dialog.module.css';

interface Props {
  open: boolean;
  onClose: () => void;
  title: string;
  children: ReactNode;
}

export const Dialog = ({ open, onClose, title, children }: Props) => {
  const isMobile = useDetectBreakpoint('sm');

  return (
    <MuiDialog
      open={open}
      onClose={onClose}
      className={classes.dialog}
      maxWidth={isMobile ? 'xl' : 'md'}
    >
      <DialogTitle className={`${classes.dialogTitle} body1Fluid`}>
        {title}
      </DialogTitle>
      <DialogContent dividers className={`${classes.dialogContent} body3Fluid`}>
        {children}
      </DialogContent>
      <DialogActions className={`${classes.dialogActions} body1Fluid`}>
        <Button className={classes.closeButton} onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </MuiDialog>
  );
};
